// extracted by mini-css-extract-plugin
module.exports = {"legend":"Legend_legend__3wWNN","dropdownList":"Legend_dropdownList__3Hdb8","dropdownTitle":"Legend_dropdownTitle__3c0C7"};